import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const MERCHANT_ACCOUNT_DETAILS_TABS = {
    CONTRACTS:
    {
        name: 'contracts',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.MERCHANT_CONTRACT_READ.name] })
    },
    USERS:
    {
        name: 'users',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.MERCHANT_CONTRACT_READ.name] })
    },
    CUSTOMIZATION:
    {
        name: 'customization',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ANDROID_MANAGE_PACKAGE.name, Permissions.MERCHANT_CONTRACT_READ.name] })
    },
    SUBSCRIPTIONS:
    {
        name: 'subscriptions',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ANDROID_MANAGE_PACKAGE.name, Permissions.MERCHANT_CONTRACT_READ.name] })
    },
    BENEFICIARIES:
    {
        name: 'beneficiaries',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ANDROID_MANAGE_PACKAGE.name, Permissions.MERCHANT_CONTRACT_READ.name] })
    }
};

MERCHANT_ACCOUNT_DETAILS_TABS.DEFAULT = MERCHANT_ACCOUNT_DETAILS_TABS.CONTRACTS;

export default MERCHANT_ACCOUNT_DETAILS_TABS;